import { jsx as o } from "react/jsx-runtime";
import r from "@kmx/mui-icons/KmxChevronRightStroked";
const a = {
  defaultProps: {
    separator: /* @__PURE__ */ o(r, { fontSize: "small" })
  }
};
export {
  a as default
};
